var map = {
	"./3ddesign1.jpeg": 1347,
	"./3ddesign2.jpeg": 3286,
	"./3ddesign3.jpeg": 1949,
	"./3ddesign4.jpeg": 1176,
	"./3ddesign5.jpeg": 9423,
	"./3ddesign6.jpeg": 8466,
	"./3ddesign7.jpeg": 2969,
	"./3ddesign8.jpeg": 2644,
	"./3ddesign9.jpeg": 5387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1210;